import React from 'react'
import Layout from '../../organisms/Layout'

export default function Contact() {
    return (
        <div>
            Contact
        </div>
    )
}
